import { render, staticRenderFns } from "./display-field-price-with-status.vue?vue&type=template&id=4a455410&scoped=true&"
import script from "./display-field-price-with-status.ts?vue&type=script&lang=ts&"
export * from "./display-field-price-with-status.ts?vue&type=script&lang=ts&"
import style0 from "./display-field-price-with-status.scss?vue&type=style&index=0&id=4a455410&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a455410",
  null
  
)

export default component.exports